import React from 'react';
import remoteFiles from '../../../../../common/remote_files';

const Landing = ({ onGetStarted }) => (
  <div className="welcome-screen">
    <div className="image-wrapper">
      <img
        src={ remoteFiles.verizon.dynamicOffer.conceptCarousel.launchImage }
        alt="Background"
        className="background-image"
      />
    </div>
    <div className="message">
      <p>
        By continuing, you accept Verizon’s
        { ' ' }
        <span className="pseudo-link">Terms & Conditions</span>
        { ' ' }
        and <span className="pseudo-link">Privacy Policy</span>.
        { ' ' }
        California customers can review our
        { ' ' }
        <span className="pseudo-link">California Privacy Notice</span>.
      </p>
      <button className="button get-started" onClick={ onGetStarted }>Get Started</button>
    </div>
  </div>
);

export default Landing;
